var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcDoorHanger = function SvgIcDoorHanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.887 11.649v-1.375c0-1.015-.826-1.841-1.841-1.841h-2.103c-.821 0-1.49-.668-1.49-1.49a1.491 1.491 0 0 1 2.895-.497c.163.462.585.76 1.075.76h.182c.377 0 .705-.168.925-.473.22-.305.276-.67.157-1.026A3.943 3.943 0 0 0 8 6.943V18.16C8 19.174 8.826 20 9.84 20h4.206c1.015 0 1.84-.826 1.84-1.84v-2.526",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.864 14.746-2.148-1.88-.716.627L13.864 16 20 10.627 19.284 10l-5.42 4.746Z",
    fill: "currentColor"
  })));
};
export default SvgIcDoorHanger;